import { useEffect } from "react";
import "./toast.css";

/**
 * Individual toast notification component
 * @param {Object} props
 * @param {string} props.id - Unique toast ID
 * @param {string} props.type - Toast type: 'success' | 'error' | 'info' | 'warning'
 * @param {string} props.message - Toast message to display
 * @param {number} props.duration - Duration in ms before auto-dismiss
 * @param {Function} props.onClose - Callback when toast is closed
 */
export default function Toast({ id, type = "info", message, duration = 3000, onClose }) {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        onClose(id);
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [id, duration, onClose]);

  const getIcon = () => {
    switch (type) {
      case "success":
        return "✓";
      case "error":
        return "✕";
      case "warning":
        return "⚠";
      case "info":
      default:
        return "ℹ";
    }
  };

  return (
    <div className={`toast toast-${type}`} role="alert">
      <div className="toast-icon">{getIcon()}</div>
      <div className="toast-message">{message}</div>
      <button
        className="toast-close"
        onClick={() => onClose(id)}
        aria-label="Cerrar notificación"
      >
        ×
      </button>
    </div>
  );
}
